module.exports = __webpack_public_path__ + "img/任务类型.e466389a.png";